// extracted by mini-css-extract-plugin
export default {"formBanner":"formBanner_formBanner__UVw23","boxUpload":"formBanner_boxUpload__SH4WD","btn":"formBanner_btn__JY45t","btnIcon":"formBanner_btnIcon__q9PVw"};